export const MAX_SHELF_LENGTH = 20
